import { AssetPlaceholder } from '../constants/assetText';
import { AssetInfo } from '../constants/informationText';
import { getAssetCategories } from 'utils/helper/assetType';

export const ASSET_TYPE_FIELDS = {
  id: {
    field: 'assetTypeId',
    label: 'Asset Type ID',
    type: 'text',
    placeholder: AssetPlaceholder.typeId,
    info: AssetInfo.typeId,
  },
  category: ({ allowableCategories, ...fieldConfig }) => ({
    field: 'category',
    type: 'select',
    required: true,
    options: getAssetCategories(allowableCategories),
    info: AssetInfo.category,
    ...fieldConfig,
  }),
  name: (fieldConfig = {}) => ({
    field: 'name',
    type: 'text',
    required: true,
    placeholder: AssetPlaceholder.typeName,
    ...fieldConfig,
  }),
  qualificationRequired: {
    field: 'qualificationRequired',
    label: 'Qualification Required',
    type: 'toggle',
    required: true,
    size: 'half',
    info: AssetInfo.qualifications,
  },
  handoverRequired: {
    field: 'handoverRequired',
    label: 'Handover Required',
    type: 'toggle',
    required: true,
    size: 'half',
    info: AssetInfo.handOver,
  },

  description: {
    field: 'description',
    type: 'textArea',
    maxLength: 250,
  },
};
